<script lang="ts">

</script>

<section id="profile-section">
    <div class="profile-section-container">
        <h2 class="profile-section-container__title">Profile</h2>
        <div class="profile-section-container__image-area">
            <img class="profile-section-container__image" src="image/sp/ryosuke-profile-image.png" alt="Profile_Image_Of_Ryosuke">
        </div>
        <div class="container-content">
            <div class="container-content__name">Ryosuke Tanaka</div>
            <div class="container-content__age">21 years old</div>
            <div class="container-content__hometown">from Fukusima in Japan</div>
            <div class="container-content__history">Hanabusho RG Club / Aomori Yamada high / Aomori Univer</div>
            <div class="container-content__body">
                In June 2022, while adjusting the trampoline, I dislocated my neck bone and suffered a serious injury that damaged my cervical vertebrae.
                He became able to controll to move his arm a little , but he still can't feel it below his collarbone.
                Ryosuke and his family need as much support as possible. We would appreciate your support and cooperation.
            </div>
        </div>
    </div>
</section>

<style>
    #profile-section {
        padding:          32px 0;
        background-color: #f1f6e7;
    }

    #profile-section .profile-section-container {
        margin:     0 auto;
        padding:    0 20px;
        text-align: center;
    }

    #profile-section .profile-section-container__title {
        margin-bottom: 48px;
        font-size:     26px;
        font-weight:   bold;
        color:         #333333;
        text-align:    center;
    }

    #profile-section .profile-section-container__title:after {
        display:          block;
        position:         absolute;
        content:          "";
        height:           4px;
        width:            25%;
        background-color: #198130;
        transform:        translate(131%, 16px);
    }

    #profile-section .profile-section-container__image-area {
        width:          80%;
        height:         300px;
        margin:         0 auto;
        border-radius:  8px;
        overflow:       hidden;
    }

    #profile-section .profile-section-container__image {
        width:      100%;
        height:     100%;
        object-fit: cover;
    }

    #profile-section .container-content {
        padding:          20px;
        background-color: white;
        border-radius:    8px;
        text-align:       left;
    }

    #profile-section .container-content__name {
        margin-bottom: 16px;
        font-size:     32px;
        position:      relative;
        font-weight:   bold;
        z-index:       2;
    }

    #profile-section .container-content__name::before {
        display:      block;
        content:      "Ryosuke Tanaka";
        position:     absolute;
        color:        #9edc93;
        font-family:  luxus-brut, cursive;
        font-style:   italic;
        opacity:      0.9;
        transform:    rotate(-7deg);
        transform:    translate(40px, 8px);
        z-index:      -1;
    }

    #profile-section .container-content__age {
        font-size: 26px;
    }

    #profile-section .container-content__hometown {
        font-size:     24px;
        margin-bottom: 8px;
    }

    #profile-section .container-content__history {
        display:          inline-block;
        margin-bottom:    32px;
        padding:          2px 8px;
        font-size:        14px;
        background-color: #eaf8f4;
    }

    #profile-section .container-content__history:after {
        content:          "";
        position:         absolute;
        display:          block;
        height:           4px;
        width:            310px;
        transform:        translate(-10px, 16px);
        background-color: #198130;
    }

    #profile-section .container-content__body {
        font-size:  18px;
    }
</style>